import { AlertOctagon } from "lucide-react";

/** A workbook goes in whole or not at all — this is what has to be fixed first. */
export const UploadBlockers = ({ data, onDismiss }) => {
  if (!data?.blockers?.length) return null;
  return (
    <div
      className="mt-8 border-2 border-[hsl(var(--at-risk))] bg-[hsl(var(--at-risk)/0.07)]"
      data-testid="upload-blockers"
    >
      <div className="flex flex-wrap items-start justify-between gap-3 border-b border-[hsl(var(--at-risk)/0.4)] p-4">
        <div className="flex items-start gap-3">
          <AlertOctagon className="mt-0.5 h-5 w-5 shrink-0 text-[hsl(var(--at-risk))]" />
          <div>
            <div className="font-display text-base font-bold">
              This file was refused — nothing was saved
            </div>
            <p className="mt-1 max-w-3xl text-xs text-muted-foreground">{data.message}</p>
          </div>
        </div>
        <button
          type="button"
          data-testid="dismiss-blockers"
          onClick={onDismiss}
          className="font-data text-[10px] uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-200 hover:text-foreground"
        >
          Dismiss
        </button>
      </div>
      <ul className="max-h-96 divide-y divide-[hsl(var(--at-risk)/0.25)] overflow-y-auto">
        {data.blockers.map((b, i) => (
          <li key={i} className="px-4 py-3" data-testid={`blocker-${i}`}>
            <div className="font-data text-[11px] uppercase tracking-wider text-[hsl(var(--at-risk))]">
              {[b.unit, b.row ? `row ${b.row}` : null, b.code].filter(Boolean).join(" · ")}
            </div>
            {b.title && <div className="mt-0.5 text-sm font-semibold">{b.title}</div>}
            <ul className="mt-1 space-y-0.5">
              {(b.reasons || []).map((r, j) => (
                <li key={j} className="text-xs text-muted-foreground">
                  — {r}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};
